import { useEffect, useState } from "react"

export default function useDebouncedSearchParam({
  search,
  searchParams,
  setSearchParams,
  delay = 400,
}) {
  const [searchTemp, setSearchTemp] = useState(search ?? "")

  useEffect(() => {
    setSearchTemp(search ?? "")
  }, [search])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const normalizedSearch = String(searchTemp ?? "")
      const currentSearch = String(search ?? "")

      if (normalizedSearch === currentSearch) {
        return
      }

      const nextParams = new URLSearchParams(searchParams)

      if (normalizedSearch.trim()) {
        nextParams.set("search", normalizedSearch)
      } else {
        nextParams.delete("search")
      }

      nextParams.delete("page")

      if (nextParams.toString() !== searchParams.toString()) {
        setSearchParams(nextParams)
      }
    }, delay)

    return () => clearTimeout(timeoutId)
  }, [delay, search, searchParams, searchTemp, setSearchParams])

  return [searchTemp, setSearchTemp]
}
